<template>
  <div>
    <fieldset>
      <legend class="fieldset__legend">{{ label }}</legend>

      <div v-for="(option, index) of options" :key="'value_' + index" class="custom-control custom-radio my-3">
        <input
          :id="option.id"
          v-model="selectedOption"
          class="custom-control-input"
          type="radio"
          :value="option.value"
        />

        <label class="custom-control-label" :for="option.id">{{ option.text }}</label>
      </div>
    </fieldset>
  </div>
</template>

<script>
// @vuese
// Prosty Radio List bez schemy
// @group FormComponents
export default {
  props: {
    // Label całego inputa
    label: {
      type: String,
      required: false,
      default: ''
    },
    // Tablica wartości do wybrania
    options: {
      type: Array,
      required: true
    },
    // Wybrana opcja
    selected: {
      type: [String, Number, Boolean],
      default: undefined,
      required: false
    }
  },
  data() {
    return { selectedOption: this.selected };
  },
  watch: {
    selectedOption(option) {
      this.$emit('selected', option);
    }
  }
};
</script>
